import React from 'react';
import { APMSME_PORTAL_URL } from '../utils/constants';

export type PortalLogoLinkProps = {
    /** Classes for the logo image (default: h-12 w-auto) */
    imgClassName?: string;
    /** Classes for the anchor wrapper */
    className?: string;
};

export const PortalLogoLink: React.FC<PortalLogoLinkProps> = ({
    imgClassName = 'h-12 w-auto',
    className = 'inline-block shrink-0',
}) => (
    <a
        href={APMSME_PORTAL_URL}
        rel="noopener noreferrer"
        className={`${className} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0D52BD] focus-visible:ring-offset-2 transition-opacity hover:opacity-90`}
        title="Go to AP MSME portal (apmsmeone.ap.gov.in)"
    >
        <img src="/apmsme_logo-min.png" alt="AP MSME Logo" className={imgClassName} />
    </a>
);
